module.exports = __webpack_public_path__ + "img/arrow-left.4ab88d01.svg";